import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, ViewChild } from "@angular/core";

import { SeveridadRiesgo } from "src/app/shared/model/gestion-proyectos/riesgos/severidad-riesgo.model";
import {
  ConfigGraficaBarra,
  ProyectoConIndicadores,
  configGraficaAvance,
  configGraficaEsfuerzo,
  configGraficaRiesgo,
  datosGraficaAvance,
  datosGraficaEsfuerzo,
  datosGraficaRiesgo,
  pintarGraficaBarra,
} from "../../utilerias/proyecto-indicadores.util";

/**
 * Página del proyecto · pestaña Resumen. Son los indicadores de la tarjeta de
 * Gestión de Proyectos (avance, esfuerzo, riesgos y defectos, con sus mismas
 * gráficas), la descripción y el último seguimiento, siempre con
 * proyecto-indicadores.util para que la tarjeta y la página digan lo mismo.
 * Defectos es el total con tenant de PROYECTOS_ETAPAS_RESUMEN.
 *
 * La maqueta de esta pestaña está pendiente (D19): por ahora reúne lo que ya
 * existe, sin funciones nuevas.
 */
@Component({
  selector: "app-proyecto-resumen",
  standalone: true,
  templateUrl: "./proyecto-resumen.component.html",
  styleUrls: ["./proyecto-resumen.component.css"],
  imports: [CommonModule],
})
export class ProyectoResumenComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() proyecto: ProyectoConIndicadores | null = null;
  /** El catálogo de severidades de riesgo, en el orden de riesgoCantidad. */
  @Input() severidad: SeveridadRiesgo[] = [];
  /** null mientras llega el resumen, o si no se pudo leer. */
  @Input() totalDefectos: number | null = null;

  @ViewChild("graficaAvance") private readonly lienzoAvance?: ElementRef<HTMLCanvasElement>;
  @ViewChild("graficaEsfuerzo") private readonly lienzoEsfuerzo?: ElementRef<HTMLCanvasElement>;
  @ViewChild("graficaRiesgo") private readonly lienzoRiesgo?: ElementRef<HTMLCanvasElement>;

  /** Las gráficas pintadas, para quitarlas antes de volver a pintar y al salir. */
  private graficas: Array<{ destroy(): void }> = [];
  private vistaLista = false;
  private cuadro: number | null = null;

  ngAfterViewInit(): void {
    this.vistaLista = true;
    this.programarGraficas();
  }

  ngOnChanges(): void {
    if (this.vistaLista) {
      this.programarGraficas();
    }
  }

  ngOnDestroy(): void {
    if (this.cuadro !== null) {
      cancelAnimationFrame(this.cuadro);
    }
    this.quitarGraficas();
  }

  /** Después de pintar la plantilla (el lienzo de riesgos solo existe si hay riesgos), como la tarjeta. */
  private programarGraficas(): void {
    if (this.cuadro !== null) {
      cancelAnimationFrame(this.cuadro);
    }
    this.cuadro = requestAnimationFrame(() => {
      this.cuadro = null;
      this.pintarGraficas();
    });
  }

  private pintarGraficas(): void {
    this.quitarGraficas();
    const proyecto = this.proyecto;
    if (!proyecto) {
      return;
    }
    const pintar = (lienzo: ElementRef<HTMLCanvasElement> | undefined, config: ConfigGraficaBarra) => {
      if (lienzo) {
        this.graficas.push(pintarGraficaBarra(lienzo.nativeElement, config));
      }
    };
    pintar(this.lienzoAvance, configGraficaAvance(datosGraficaAvance(proyecto)));
    pintar(this.lienzoEsfuerzo, configGraficaEsfuerzo(datosGraficaEsfuerzo(proyecto)));
    if (proyecto.existenRiesgos) {
      pintar(this.lienzoRiesgo, configGraficaRiesgo(datosGraficaRiesgo(proyecto)));
    }
  }

  private quitarGraficas(): void {
    this.graficas.forEach((grafica) => grafica.destroy());
    this.graficas = [];
  }
}
